import { marked } from "marked";
import DOMPurify from "dompurify";

// To convert string to html
export const convertMarkdownToHTML = (markdown) => {
  // return marked(markdown);
  markdown = markdown.replace(/\\n/g, "\n");
  const correctedMarkdown = markdown.replace(/(\|[^\n]*\|\n)(?!\|)/g, "$1\n");
  const rawHtml = marked(correctedMarkdown);
  const html = DOMPurify.sanitize(rawHtml, { ADD_ATTR: ['target', 'rel'] });

  // Add custom styles for tables
  let styledHtml = html
    .replace(/<table>([\s\S]*?)<\/table>/g, (match, content) => {
      const colCount = (content.match(/<th/g) || []).length;

      // Find max data length per column
      const colMaxLens = [];
      const dataRows = content.match(/<tr>(?:(?!<th)[\s\S])*?<td>[\s\S]*?<\/tr>/g) || [];
      dataRows.forEach(row => {
        const cells = row.match(/<td>(.*?)<\/td>/g) || [];
        cells.forEach((cell, i) => {
          const text = cell.replace(/<[^>]*>/g, '').trim();
          colMaxLens[i] = Math.max(colMaxLens[i] || 0, text.length);
        });
      });

      // Fixed for ≤6 cols, auto for >6 cols (allows horizontal scroll)
      const sizeClass = colCount <= 6 ? 'chat-with-data-table-fixed' : 'chat-with-data-table-auto';

      // Replace <th> with wrap/nowrap class based on column data length
      let colIdx = 0;
      const processedContent = content.replace(/<th>(.*?)<\/th>/g, (m, thContent) => {
        const maxDataLen = colMaxLens[colIdx] || 0;
        const wrapClass = maxDataLen <= 12 ? 'chat-with-data-th-wrap' : 'chat-with-data-th-nowrap';
        colIdx++;
        return `<th class="chat-with-data-th-tag ${wrapClass}">${thContent}</th>`;
      });

      return `<div class="chat-with-data-table-wrapper"><table class="chat-with-data-table-tag ${sizeClass}">${processedContent}</table></div>`;
    })
    .replace(/<thead>/g, `<thead class="chat-with-data-thead-tag">`)
    .replace(/<tr>/g, `<tr class="chat-with-data-tr-tag">`)
    .replace(/<td>/g, `<td class="chat-with-data-td-tag">`)
    .replace(/<p>/g, `<p class="chat-with-data-p-tag">`)
    .replace(
      /<li>/g,
      `<li class="chat-with-data-li-tag">` // Style for list items
    )
    .replace(
      /<strong>/g,
      `<strong class="chat-with-data-strong-tag">` // Style for bold text
    )
    .replace(
      /<em>/g,
      `<em class="chat-with-data-em-tag">` // Style for italic text
    )
    .replace(/<h1>/g, `<h1 class="chat-with-data-h1-tag">`)
    .replace(/<h2>/g, `<h2 class="chat-with-data-h2-tag">`)
    .replace(/<h3>/g, `<h3 class="chat-with-data-h3-tag">`)
    .replace(/<h4>/g, `<h4 class="chat-with-data-h4-tag">`)
    .replace(/<h5>/g, `<h5 class="chat-with-data-h5-tag">`)
    .replace(/<h6>/g, `<h6 class="chat-with-data-h6-tag">`)
    .replace(
      /<a href="([^"]+)">/g,
      `<a href="$1" target="_blank" rel="noopener noreferrer">`
    ); // Adds target="_blank" to all links

  // Wrap the HTML in a div with a specified width
  let updatedStyledHtml = `<div class="chat-with-data-main-container-desktop" style="overflow: visible">${styledHtml}</div>`;
  return updatedStyledHtml;
};
